import { PurchaseCompletionStatus, Purchase } from '@/clickbuy/purchase/models/purchase.model';
import { Client } from '@/manager/client/client.model';


export interface CompanionInterface {
    id?: string;
    client?: Client;
    convocationTarget?: string;
    completionStatus?: PurchaseCompletionStatus;
}

export class Companion implements CompanionInterface {
    public id?: string;
    public client?: Client;
    public convocationTarget?: string;
    public completionStatus?: PurchaseCompletionStatus;

    constructor() {
        this.client = new Client();
        this.completionStatus = PurchaseCompletionStatus.Pending;
    }
}
